module.exports = __webpack_public_path__ + "static/media/conner-narrow.8b9dd285.png";